export default __webpack_public_path__ + "static/media/x_web.6e523e56.svg";